import { SharedAppConstants } from '@tock/shared-app-constants';

export function fetch(historyId: string): ApiAction {
  return {
    TockApi: {
      getProto: `/business/inventory/schedule/history/${historyId}`,
      type: SharedAppConstants.BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH,
    },
  };
}

export function fetchUnassignedCsv(historyId: string): ApiAction {
  return {
    TockApi: {
      getFile: `/business/inventory/schedule/history/${historyId}/unassigned`,
      type: SharedAppConstants.BUSINESS_INVENTORY_SCHEDULE_HISTORY_FETCH_UNASSIGNED_CSV,
    },
  };
}
